import React from 'react';
import PropTypes from 'prop-types';
import {connect, batch} from 'react-redux';
import {bindActionCreators} from 'redux';
import DispenseReport from './DispenseReport';
import DispenseReportHeader from './DispenseReportHeader';
import {PageLayout} from '../../components';
import withIntl from '../../lib/withIntl';
import {changeView} from '../../stores/actions/appStateAction';
import {setRuntimeReportVisible} from '../../stores/actions/runtimeStateAction';
import {downloadDispenseReportCsv, printDispenseReport} from '../../stores/business/reportStateBusiness';
import {saveState} from '../../stores/business/stateBusiness';
import {showModal, hideModal} from '../../stores/actions/modalStateAction';
import './DispenseReport.scss';

function mapStateToProps(state) {
  return {
    reportState: state.reportState,
    labwareState: state.labwareState,
    isHumidifierInstalled: state.humidifierState.isHumidifierInstalled,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    appStateActionChangeView: bindActionCreators(changeView, dispatch),
    runtimeStateActionSetRuntimeReportVisible: bindActionCreators(setRuntimeReportVisible, dispatch),
    stateBusinessSaveState: bindActionCreators(saveState, dispatch),
    reportStateBusinessDownloadDispenseReportCsv: bindActionCreators(downloadDispenseReportCsv, dispatch),
    reportStateBusinessPrintDispenseReport: bindActionCreators(printDispenseReport, dispatch),
    modalStateActionShowModal: bindActionCreators(showModal, dispatch),
    modalStateActionHideModal: bindActionCreators(hideModal, dispatch),
  };
}

function DispenseReportContainer({
  labwareState,
  reportState,
  intl,
  runtimeStateActionSetRuntimeReportVisible,
  stateBusinessSaveState,
  reportStateBusinessDownloadDispenseReportCsv,
  reportStateBusinessPrintDispenseReport,
  // modalStateActionShowModal,
  // modalStateActionHideModal,
  isHumidifierInstalled,
}) {
  const {protocolName, protocolOwner, protocolRunBy, summary} = reportState;

  const onBack = () => {
    batch(() => {
      runtimeStateActionSetRuntimeReportVisible(false);
      stateBusinessSaveState();
    });
  };

  const onPrint = () => {
    const pdfBuff = reportStateBusinessPrintDispenseReport();
    pdfBuff.print({}, window.frames.printPdf);
  };

  return (
    <PageLayout>
      <PageLayout.Header>
        <DispenseReportHeader
          intl={intl}
          reportState={reportState}
          onDownloadClick={() => reportStateBusinessDownloadDispenseReportCsv()}
          onPrintClick={onPrint}
          onBack={onBack}
        />
      </PageLayout.Header>
      <PageLayout.Content>
        <DispenseReport
          intl={intl}
          protocolName={protocolName}
          protocolOwner={protocolOwner}
          protocolRunBy={protocolRunBy}
          summary={summary}
          labwareState={labwareState}
          isHumidifierInstalled={isHumidifierInstalled}
        />
      </PageLayout.Content>
      <iframe
        title="printPdf"
        id="printPdf"
        name="printPdf"
        style={{
          position: 'fixed',
          top: '0px',
          left: '0px',
          display: 'block',
          padding: '0px',
          border: '0px',
          margin: '0px',
          visibility: 'hidden',
          opacity: '0',
        }}
      />
    </PageLayout>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(withIntl(DispenseReportContainer));

DispenseReportContainer.propTypes = {
  intl: PropTypes.any.isRequired,
  labwareState: PropTypes.object.isRequired,
  reportState: PropTypes.object.isRequired,
  runtimeStateActionSetRuntimeReportVisible: PropTypes.func.isRequired,
  stateBusinessSaveState: PropTypes.func.isRequired,
  reportStateBusinessDownloadDispenseReportCsv: PropTypes.func.isRequired,
  reportStateBusinessPrintDispenseReport: PropTypes.func.isRequired,
  // modalStateActionShowModal: PropTypes.func.isRequired,
  // modalStateActionHideModal: PropTypes.func.isRequired,
  isHumidifierInstalled: PropTypes.bool.isRequired,
};
